<template>
  <!-- 使用 a-config-provider 包裹整个应用，传入主题和 locale -->
  <a-config-provider
    :theme="{
      token: themeComputed, // 主题配置使用 themeComputed 动态计算
      components: components // 组件配置直接使用预定义的 components
    }"
    :locale="language"
    prefix-cls="mainPrefix"
  >
    <RouterView /> <!-- 渲染路由视图 -->
    <!-- 如果正在加载中，则显示全局加载动画 -->
    <div v-if="loading" class="global-loading-container">
      <a-spin /> <!-- 使用 a-spin 作为加载动画 -->
    </div>
  </a-config-provider>
</template>

<script setup>
import { computed, watch, ref, toRefs } from 'vue'
import store from './store' // 引入 Vuex store
import { theme, components } from '@/theme/config' // 引入主题和组件配置
import { useRouter } from 'vue-router' // 使用 Vue Router
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
import { zh } from '@/i18n/zh'
import { en } from '@/i18n/en'

const language = ref(zh) // 创建语言环境计算属性

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 引入 dayjs 的中文语言包

const themeComputed = ref(Object.assign({}, theme)) // 创建主题计算属性

dayjs.locale('zh-cn') // 设置 dayjs 的本地化语言为中文

const router = useRouter() // 获取路由实例

const loading = computed(() => {
  return store.getters['system/loading'] // 获取加载状态
})

const isLogin = computed(() => {
  return store.getters['user/isLogin'] // 获取登录状态
})
const { locale: lang } = toRefs(store.getters) // 获取语言环境
// 监听语言环境的变化
watch(lang, newVal => {
  locale.value = newVal
  if (newVal === 'zhCn') {
    language.value = zh
  } else {
    language.value = en
  }
}, { immediate: true })

// 监听主题颜色的变化
watch(() => store.getters.themeColor, (color) => {
  themeComputed.value = Object.assign({}, theme, { colorPrimary: color }) // 更新主题计算属性的值
}, { immediate: true })
// 监听登录状态的变化
watch(isLogin, (cur) => {
  if (!cur) {
    router.push({ 'name': 'login' }) // 如果未登录，则跳转到登录页面
  }
})

</script>

<style>
/* 定义自定义字体 */
@font-face {
  font-family: "Helvetica Neue"; /* 任意命名 */
  src: url("~@/assets/font/HelveticaNeueLTStd-Roman.otf") format("truetype");
}

/* 全局样式 */
body {
  margin: 0 !important;
  font-family: Helvetica Neue, -apple-system, BlinkMacSystemFont, Segoe UI,
  PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
  Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  font-variant: tabular-nums;
  line-height: 1.5;
  font-feature-settings: "tnum";
}

/* 根节点样式 */
#app {
  background: #f3f5f8; /* 设置背景颜色 */
  height: 100%;
}

/* 全局加载动画容器样式 */
.global-loading-container {
  background: rgba(255, 255, 255, 0.3); /* 设置半透明白色背景 */
  position: fixed; /* 固定定位 */
  width: 100%; /* 宽度占满屏幕 */
  height: 100%; /* 高度占满屏幕 */
  z-index: 9999; /* 设置层级 */
  left: 0; /* 距左边界距离为 0 */
  top: 0; /* 距顶部距离为 0 */
  display: flex; /* 使用 Flex 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.mainPrefix-select-selector,.mainPrefix-input-disabled,.mainPrefix-picker-input >input[disabled],.mainPrefix-select-selection-item{
  color: #333 !important;
}
</style>
